import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import printJS from 'print-js';
import { http } from 'services/http';
import type { IWhTaskStickerGeneratorProps } from './types';

export const WhTaskStickerGenerator: React.FC<IWhTaskStickerGeneratorProps> = (props) => {
  const { whTaskId } = props;
  const { t } = useTranslation();

  const handleClick = async () => {
    const result = await http.get(`/v1/warehouse-tasks/${whTaskId}/sticker`);
    printJS({ printable: result.data, type: 'pdf', base64: true });
  };

  return (
    <Button icon={<CopyOutlined />} onClick={handleClick}>
      {t('common:sticker')}
    </Button>
  );
};
